'use client';
import Typography from '@/components/shared/typography/typography.component';
import { useState } from 'react';
import { useTranslation } from '@/hook';
import { XBlue } from '../../../../public/Images';
import classes from './styles.module.scss';
import Image from 'next/image';

const ReserveInfoBox = () => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState<boolean>(true);

    return isOpen ? (
        <div className={classes.container} style={{ marginTop: '1rem' }}>
            <div className={classes.ripple} />
            <div className={classes.header}>
                <Typography variant="body2Medium" className={classes.title}>
                    {t('reservedFor24h')}
                </Typography>

                <Image
                    src={XBlue}
                    alt="XPrimary"
                    width={10}
                    height={10}
                    onClick={() => setIsOpen(false)}
                />
            </div>

            <Typography
                component="div"
                variant="body2"
                className={classes.description}
            >
                <div
                    dangerouslySetInnerHTML={{ __html: t('reservedTagDesc') }}
                />
            </Typography>
        </div>
    ) : null;
};

export default ReserveInfoBox;
